module.exports = __webpack_public_path__ + "static/media/aroldo-pensando-esquerda.e7bbeb2b.svg";